import React from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { DonateForm } from "@/components/forms/DonateForm";
import { ShieldCheck, ReceiptText, Building2, Lock } from "lucide-react";
import { useSite } from "@/lib/site";

export const DonateSection = () => {
  const site = useSite();
  return (
  <section id="donate" className="bg-background">
    <div className="container-wide py-16 lg:py-24">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionHeader eyebrow="Donate" title="100% Transparent Donations." lead="Choose your preferred method — UPI, Bank Transfer, Credit/Debit Card, or Netbanking. Every donation is tagged to a program and audited annually." />
          <Reveal><div className="rounded-xl border border-[hsl(var(--border))] p-6 bg-card"><DonateForm /></div></Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.04}>
            <div className="relative rounded-xl overflow-hidden border border-[hsl(var(--border))] caf-shadow mb-5" data-testid="donate-empathy-image">
              <img src={site.donate_image_url} alt="A helping hand offering food to a person in need" className="w-full h-52 object-cover" loading="lazy" />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent p-4">
                <div className="text-white font-semibold text-sm">Your ₹500 feeds a family for a week.</div>
                <div className="text-white/80 text-xs mt-0.5">Every rupee reaches the ground — tracked, tagged and audited.</div>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="rounded-xl border border-[hsl(var(--border))] p-6 bg-[hsl(var(--surface-tint))]">
              <h3 className="heading-3 text-lg">Why donate to CAF?</h3>
              <ul className="mt-4 space-y-4 text-sm">
                {[[ShieldCheck, "80G tax-deductible", "Receive an 80G receipt within 24 hours of payment confirmation."], [Lock, "Secure payments", "Payment gateway with bank-grade encryption (Razorpay coming online)."], [ReceiptText, "Open books", "Live public donation ledger; statutory audit due FY 2026-27."], [Building2, "CSR-1 ready", "Structured MoUs and utilization certificates for corporate partners."]].map(([Icon, t, d]) => (
                  <li key={t} className="flex gap-3">
                    <div className="h-9 w-9 rounded-md bg-card text-[hsl(var(--navy))] border border-[hsl(var(--border))] grid place-items-center"><Icon className="h-4.5 w-4.5" /></div>
                    <div><div className="font-semibold text-[hsl(var(--navy))]">{t}</div><div className="text-[hsl(var(--muted-ink))]">{d}</div></div>
                  </li>
                ))}
              </ul>
              <div className="mt-6 rounded-lg bg-card border border-[hsl(var(--border))] p-4 text-xs text-[hsl(var(--muted-ink))]">Refunds: If a donation is made in error, please write to donate@caf.org.in within 7 days. See our Refund Policy.</div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
  );
};
